/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyMessageOnAzure
 */
export interface EmergencyMessageOnAzure {
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    emergency_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    message_kind: string;
    /**
     * 
     * @type {number}
     * @memberof EmergencyMessageOnAzure
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmergencyMessageOnAzure
     */
    longitude?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    sender_auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    sender_first_name: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    sender_last_name: string;
    /**
     * 
     * @type {number}
     * @memberof EmergencyMessageOnAzure
     */
    sent_timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof EmergencyMessageOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the EmergencyMessageOnAzure interface.
 */
export function instanceOfEmergencyMessageOnAzure(value: object): value is EmergencyMessageOnAzure {
    if (!('emergency_id' in value) || value['emergency_id'] === undefined) return false;
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('message_kind' in value) || value['message_kind'] === undefined) return false;
    if (!('sender_auth_id' in value) || value['sender_auth_id'] === undefined) return false;
    if (!('sender_first_name' in value) || value['sender_first_name'] === undefined) return false;
    if (!('sender_last_name' in value) || value['sender_last_name'] === undefined) return false;
    if (!('sent_timestamp' in value) || value['sent_timestamp'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function EmergencyMessageOnAzureFromJSON(json: any): EmergencyMessageOnAzure {
    return EmergencyMessageOnAzureFromJSONTyped(json, false);
}

export function EmergencyMessageOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyMessageOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency_id': json['emergency_id'],
        'org_code': json['org_code'],
        'content': json['content'] == null ? undefined : json['content'],
        'message_kind': json['message_kind'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'address': json['address'] == null ? undefined : json['address'],
        'sender_auth_id': json['sender_auth_id'],
        'sender_first_name': json['sender_first_name'],
        'sender_last_name': json['sender_last_name'],
        'sent_timestamp': json['sent_timestamp'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function EmergencyMessageOnAzureToJSON(json: any): EmergencyMessageOnAzure {
    return EmergencyMessageOnAzureToJSONTyped(json, false);
}

export function EmergencyMessageOnAzureToJSONTyped(value?: EmergencyMessageOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency_id': value['emergency_id'],
        'org_code': value['org_code'],
        'content': value['content'],
        'message_kind': value['message_kind'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'address': value['address'],
        'sender_auth_id': value['sender_auth_id'],
        'sender_first_name': value['sender_first_name'],
        'sender_last_name': value['sender_last_name'],
        'sent_timestamp': value['sent_timestamp'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

